module.exports = __webpack_public_path__ + "static/media/bk_swiper.e799846e.jpg";